module.exports = __webpack_public_path__ + "img/bgsalud1920x1080.d8403a14.jpg";